"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  highlightPreTag: "<ais-highlight-0000000000>",
  highlightPostTag: "</ais-highlight-0000000000>"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-instantsearch/src/core/highlightTags.js
// module id = ./node_modules/react-instantsearch/src/core/highlightTags.js
// module chunks = 0